export default __webpack_public_path__ + "static/media/favorite-icon.90a70cfa.svg";